import PublicLayout from "@/components/PublicLayout";

const Draft = () => (
  <p className="mb-6 rounded-xl bg-amber-50 p-4 text-sm text-amber-900" data-testid="legal-draft-banner">
    Draft for review — this document has not yet been reviewed by a lawyer and does not claim compliance with any specific law or certification.
  </p>
);

const Doc = ({ title, sections }) => (
  <PublicLayout>
    <article className="mx-auto max-w-3xl px-4 py-14">
      <h1 className="text-4xl font-extrabold">{title}</h1>
      <p className="mt-2 text-sm text-slate-500">Last updated: October 2026</p>
      <div className="mt-6"><Draft /></div>
      {sections.map(([h, p]) => (
        <section key={h} className="mb-6"><h2 className="text-lg font-bold">{h}</h2><p className="mt-2 text-slate-700">{p}</p></section>
      ))}
    </article>
  </PublicLayout>
);

export const Privacy = () => (
  <Doc title="Privacy policy" sections={[
    ["What we collect", "Account details (name, email, password hash or Google profile), the trip information you and your organizers enter (itineraries, costs, recorded payments, room preferences, flight details, documents), and basic technical logs needed to keep the service secure."],
    ["How we use it", "Only to run Triply: show your trips, compute your costs, send transactional emails you've enabled (invites, reminders, announcements) and keep accounts secure. We do not sell personal data and do not use private trip details for marketing."],
    ["Who can see your trip data", "Your private details — costs, payments, booking references, preferences and private documents — are visible only to you and that trip's organizers. Public trip guides show only information an organizer chooses to publish, never finances or traveler details."],
    ["Payments", "Triply does not process payments between travelers and organizers. Subscription payments are handled by Stripe; we never store card numbers."],
    ["Your choices", "You can change email preferences, export your data, or delete your account at any time from Account settings."],
    ["Contact", "Questions or privacy requests: use the support form on the Help page. [Founder to add a privacy contact email]"],
  ]} />
);

export const Terms = () => (
  <Doc title="Terms of service" sections={[
    ["Using Triply", "Triply is a planning tool for group travel. You're responsible for the accuracy of what you enter and for having permission to add other people's details to a trip."],
    ["Money between travelers", "Organizers collect trip money outside Triply. Payments recorded in Triply are manual records entered by organizers and are not verified by Triply. Triply is not a party to, and is not responsible for, any arrangement between travelers and organizers."],
    ["Subscriptions", "Premium and Pro are monthly subscriptions billed through Stripe. You can cancel anytime; access continues until the end of the paid period. Downgrading never deletes your trips or records."],
    ["Acceptable use", "No spam, harassment, unlawful content or attempts to access other people's data. We may limit accounts that abuse the service, and we review serious cases before taking permanent action."],
    ["No booking or travel guarantees", "Triply does not book travel or verify prices, schedules or availability. Always confirm details with the provider."],
    ["Changes", "We'll notify you of material changes to these terms. [Founder to add governing law and business entity details]"],
  ]} />
);
